import { type FormEvent, type ReactNode } from 'react'
import { Head, Link, useForm } from '@inertiajs/react'
import { ArrowLeft } from 'lucide-react'
import DashboardLayout from '@/components/DashboardLayout'
import PostForm, { type PostFormData } from '@/components/dashboard/PostForm'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import type { LinkableEvent } from '@/types'

type Props = {
  currently_pinned_id: string | null
  linkable_events: LinkableEvent[]
  errors?: Partial<Record<'body' | 'image' | 'linked_event_id', string[]>>
}

export default function DashboardPostsNew({ currently_pinned_id, linkable_events, errors }: Props) {
  const form = useForm<PostFormData>({
    body: '',
    image: null,
    remove_image: false,
    image_preview_url: null,
    linked_event_id: null,
    pinned: false,
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    form.transform(({ image_preview_url: _ignored, ...rest }) => ({ post: rest }))
    form.post('/dashboard/posts')
  }

  return (
    <>
      <Head title="New post" />
      <div className="mx-auto max-w-3xl px-4 py-10 sm:px-6 lg:px-8">
        <Button asChild variant="ghost" size="sm" className="mb-4">
          <Link href="/dashboard/posts">
            <ArrowLeft className="size-4" />
            Back to posts
          </Link>
        </Button>

        <Card>
          <CardHeader>
            <CardTitle>New post</CardTitle>
          </CardHeader>
          <CardContent>
            <PostForm
              form={form}
              linkableEvents={linkable_events}
              currentlyPinnedId={currently_pinned_id}
              submitLabel="Publish"
              onSubmit={handleSubmit}
              errors={errors}
            />
          </CardContent>
        </Card>
      </div>
    </>
  )
}

DashboardPostsNew.layout = (page: ReactNode) => <DashboardLayout>{page}</DashboardLayout>
